export default __webpack_public_path__ + "static/1079-cf7992409a7cba95c8fabad0e4ac81cd.gif";